/* eslint-disable */
import { Message } from 'iview';

import axios from 'axios';
import utils from './libs/utils';
/* eslint-enable */

/** ******************************** NEW API 2 ********************************************* */

const api2client = axios.create({
  baseURL: utils.config.API2_URL
});

api2client.interceptors.response.use(
  (resp) => {
    if (resp.data) {
      resp.data.status = resp.status;
    }
    if (resp.status === 201) {
      Message.info(resp.data.msgCode);
    }
    return resp.data;
  },
  (err) => {
    const errorResponse = err.response;
    const error = errorResponse.data;
    error.status = errorResponse.status;

    Message.error(error.msgCode);
    return Promise.reject(new Error(error));
  },
);

const api2 = {
  async execute(method, url, data) {
    try {
      const resp = await api2client({
        method,
        url,
        data
      });

      return resp.data;
    } catch (err) {
      return err.response;
    }
  },

  resendVerifyEmail(email) {
    return this.execute('post', '/aun/p/authn/resendverifyemail', email);
  },
  verify(code) {
    return this.execute('get', `/aun/p/authn/verify/${code}`);
  },
  getPasswordResetLink(email) {
    return this.execute('post', '/aun/p/authn/getpassresetlink', email);
  },
  resetPassword(payload) {
    return this.execute('post', 'aun/p/authn/resetpassword', payload);
  }
};

export default api2;
